import React from "react";
import "./App.css";
import AffilliatePageLayout from "./components/AffilliatePageLayout";

function App() {
  return <AffilliatePageLayout />;
}

export default App;
